// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"d0dd19c2","227":"374fcc29","627":"e0ad81fc","650":"c09c4ef1","740":"64a7b12b","761":"64a7b12b"}[chunkId] + ".chunk.css";
};